import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  Slide,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import getClientService from "../../../../services/getClientService";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import { NotificationManager } from "react-notifications";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddEdit = ({
  setOpenAddDialog,
  openAddDialog,
  selectedClient,
  setSelectedClient,
  fetchCleint,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpenAddDialog(false);
    formik.resetForm();
    setSelectedClient(null);
    setShowPasswordField(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    phone_num: Yup.string().optional(),
    email: Yup.string().email("Invalid email").required("Email is required"),
    ...(showPasswordField || !selectedClient
      ? {
          password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
        }
      : {}),
  });

  // Set up Formik
  const formik = useFormik({
    initialValues: {
      first_name: selectedClient?.first_name || "",
      last_name: selectedClient?.last_name || "",
      phone_num: selectedClient?.phone_num || "",
      email: selectedClient?.email || "",
      password: "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      const submitData = { ...values };
      if (selectedClient && !showPasswordField) {
        delete submitData.password;
      }

      try {
        let response;
        if (selectedClient) {
          response = await getClientService.UpdateClient({
            ...submitData,
            id: selectedClient.id,
          });
          console.log(response);
        } else {
          response = await getClientService.CreateClient(submitData);
          console.log(response);
        }
        if (response) {
          fetchCleint();
          handleClose();
        }
      } catch (error) {
        // Try to extract and show backend error message
        let message = "An error occurred.";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (error?.message) {
          try {
            // Try to parse error message if it's a JSON string
            const parsed = JSON.parse(error.message);
            if (parsed?.message) message = parsed.message;
          } catch {}
        }
        NotificationManager.error(message, "Error");
        console.error(
          selectedClient ? "Error updating client:" : "Error creating client:",
          error
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <React.Fragment>
      <Dialog
        open={openAddDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth={"sm"}
      >
        <DialogTitle className="modal_header_dealog">
          {selectedClient ? "Edit" : "Add"} Client
        </DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <div className="row">
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="First Name"
                    name="first_name"
                    variant="outlined"
                    value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.first_name &&
                      Boolean(formik.errors.first_name)
                    }
                    helperText={
                      formik.touched.first_name && formik.errors.first_name
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Last Name"
                    name="last_name"
                    variant="outlined"
                    value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.last_name &&
                      Boolean(formik.errors.last_name)
                    }
                    helperText={
                      formik.touched.last_name && formik.errors.last_name
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Phone Number"
                    name="phone_num"
                    variant="outlined"
                    value={formik.values.phone_num}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.phone_num &&
                      Boolean(formik.errors.phone_num)
                    }
                    helperText={
                      formik.touched.phone_num && formik.errors.phone_num
                    }
                  />
                </FormControl>
              </div>
              <div className="col-6">
                <FormControl className="mt-3" fullWidth>
                  <TextField
                    size="small"
                    label="Email"
                    name="email"
                    variant="outlined"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </FormControl>
              </div>
              {selectedClient && !showPasswordField && (
                <div className="col-12 mt-3">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setShowPasswordField(true)}
                  >
                    Change Password
                  </Button>
                </div>
              )}
              {(showPasswordField || !selectedClient) && (
                <div className="col-6">
                  <FormControl className="mt-3" fullWidth>
                    <TextField
                      size="small"
                      label="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      variant="outlined"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.password &&
                        Boolean(formik.errors.password)
                      }
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined" disabled={loading}>
              Cancel
            </Button>
            <Button
              color="success"
              variant="outlined"
              type="submit"
              disabled={loading}
            >
              {loading
                ? selectedClient
                  ? "Updating..."
                  : "Adding..."
                : selectedClient
                ? "Update"
                : "Add"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default AddEdit;
